import { useState } from "react";

import IconCheckCircle from "@assets/svg/IconCheckCircle";
import IconInfoFilled from "@assets/svg/IconInfoFilled";
import { useIdlePreloadArt } from "@/blueprint/components/ResponsiveArt/ResponsiveArt";
import HsaFsaEligibilityModal, {
  ELIGIBILITY_ART,
} from "@/views/shop/sections/HsaFsaEligibilityModal";
import { CONFIGURATOR } from "@/views/shop/shopContent";

const { eligibilityBadge } = CONFIGURATOR;

/* The whole bar is the button: the ⓘ cannot be a second one, since a button
   inside a button is invalid. */
const EligibilityBadge = () => {
  const [explainerOpen, setExplainerOpen] = useState(false);
  useIdlePreloadArt(ELIGIBILITY_ART);

  return (
    <>
      <button
        type="button"
        onClick={() => setExplainerOpen(true)}
        aria-haspopup="dialog"
        className="tap-target flex w-full items-center justify-between gap-[12px] rounded-8 bg-tint-black-5 px-[16px] py-[8px] text-left transition-colors duration-quick ease-out-strong hover:bg-tint-black-9 motion-reduce:transition-none"
      >
        <span className="flex items-center gap-[4px] font-ppMori text-paragraph-sm font-medium text-tint-black-70">
          <IconCheckCircle className="size-[15px] shrink-0" />
          {eligibilityBadge.label}
        </span>
        <span
          aria-hidden
          className="flex size-[24px] shrink-0 items-center justify-center text-tint-black-60"
        >
          <IconInfoFilled className="size-[24px]" />
        </span>
      </button>
      <HsaFsaEligibilityModal
        open={explainerOpen}
        onClose={() => setExplainerOpen(false)}
      />
    </>
  );
};

export default EligibilityBadge;
